export default {
  path: "/course",
  meta: {
    title: "直播课表",
  },
  component: () => import("@/views/common/moduleMain.vue"),
  children: [
    {
      path: "/broast",
      meta: {
        title: "直播课表",
      },
      component: () => import("@/views/course/broast.vue"),
    },
    {
      path: "/course_detail",
      meta: {
        title: "直播课详情",
      },
      component: () => import("@/views/course/courseDetail.vue"),
    },
  ],
};
